import React, { Component } from 'react'
import DashboardLayout from '../layouts/DashboardLayout'
import CheckLoginStatus from '../conditions/CheckLoginStatus'
import Card from '../components/Card'
import Paragraph from '../components/Paragraph'
import Grid from '../components/Grid'
import styled from 'styled-components'

const PlaylistLink = styled.a`
  display: flex;
  background: var(--${props => props.disabled ? 'gray' : props.color});
  color: #fff;
  padding: 0.75rem 1.25rem;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  transition: all 0.2s;
  font-weight: 300;
  border-radius: 1.25rem;
  width: 100%;
  text-decoration: none;
  text-align: center;
  align-items: center;
  justify-content: center;
  &:hover {
    box-shadow: ${props => props.disabled ? 'none' : `0 0 5px var(--${props.color})`};
  }
`
// comment
export default class CounselorTraining extends Component {
  render() {
    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <DashboardLayout title="SEE Counselor Training" backHref="/resources" backText="Resources">
          <Card>
            <Card.Pad>
              <Paragraph str="Below are links to PowerPoint files for counselor training. Please use Microsoft PowerPoint 2010 or later." />
            </Card.Pad>
          </Card>
          <Grid>
            <Grid.HalfCell>
              <PlaylistLink color="blue" href="https://drive.google.com/open?id=1JrovUtt0X3m3FoQ6ujexX5S7qBHPmuU_" target="_blank">Day 1 (PPT)</PlaylistLink>
            </Grid.HalfCell>
            <Grid.HalfCell>
              <PlaylistLink color="blue" href="https://drive.google.com/open?id=1_6JdDf0tHLrIcIW_5b3hCBvBI31cDsPJ" target="_blank">Day 2 (PPT)</PlaylistLink>
            </Grid.HalfCell>
            <Grid.HalfCell>
              <PlaylistLink color="blue" href="https://drive.google.com/open?id=1pl5Byh-67f7Q5aYjGMXnFr3LYhh6jLud" target="_blank">Booster Session (PPT)</PlaylistLink>
            </Grid.HalfCell>
            <Grid.HalfCell>
              <PlaylistLink color="blue" href="https://drive.google.com/open?id=10M85j5TmEmXF4VJ3VHw6Fv250mpoNfIM" target="_blank">SEE MI Training 10.2022 (PPT)</PlaylistLink>
            </Grid.HalfCell>
            <Grid.HalfCell>
              <PlaylistLink color="blue" href="https://drive.google.com/drive/folders/1VwJrgAyuZ05-2tzU-PgoHgNxFLbFfGfo?usp=sharing" target="_blank">All Resources</PlaylistLink>
            </Grid.HalfCell>
          </Grid>
        </DashboardLayout>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/CounselorTraining.js